/*
 * File: MenuKeys.ts
 * Project: receiving-rules
 * -----
 * Last Modified: 01 Oct 2020 8:04:24 pm
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */
export enum MenuKeys {
  logout = 'Log Out',
  about = 'About'
}

export enum SalesOrderFormMenuKeys {
  UserDetails = 'user-details',
  AssignRoles = 'assign-roles',
  AssignDivisions = 'assign-divisions',
  Overview = 'overview'
}
